/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Report_MispronunciationInputs */

const en_dialog_report_mispronunciation = /** @type {(inputs: Dialog_Report_MispronunciationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report Mispronunciation`)
};

const es_dialog_report_mispronunciation = /** @type {(inputs: Dialog_Report_MispronunciationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reportar error de pronunciación`)
};

/**
* | output |
* | --- |
* | "Report Mispronunciation" |
*
* @param {Dialog_Report_MispronunciationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_report_mispronunciation = /** @type {((inputs?: Dialog_Report_MispronunciationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Report_MispronunciationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_report_mispronunciation(inputs)
	return en_dialog_report_mispronunciation(inputs)
});